<router-outlet></router-outlet>
<app-toasts />
<app-confirm-dialog />
